import { Link } from "react-router-dom";

const FooterSection = () => {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#F7F8FA] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 lg:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <a href="/" className="inline-block mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/57b8b140-7aaa-4dba-81ff-f2e4a216eacc.png"
                alt="Strony www dla firm usługowych"
                className="h-8 w-auto object-contain"
              />
            </a>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
              Projektuję nowoczesne strony internetowe dla lokalnych firm usługowych.
              Strony, które pomagają zdobywać klientów — nie tylko dobrze wyglądają.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="tel:+48509963499"
                className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#0F2557] transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-sm"></i>
                </div>
                +48 509 963 499
              </a>
            </div>
            <div className="flex items-center gap-3 mt-2">
              <a
                href="mailto:tomasz.kdp@gmail.com"
                className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#0F2557] transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                tomasz.kdp@gmail.com
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-[#1A1A2E] text-sm mb-4">Nawigacja</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: "Dla kogo", href: "#dla-kogo" },
                { label: "Co dostajesz", href: "#co-dostajesz" },
                { label: "Jak to działa", href: "#jak-to-dziala" },
                { label: "Opinie", href: "#opinie" },
                { label: "Pakiety", href: "#pakiety" },
                { label: "FAQ", href: "#faq" },
                { label: "Kontakt", href: "#kontakt" },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link.href);
                    }}
                    className="text-sm text-gray-500 hover:text-[#0F2557] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-[#1A1A2E] text-sm mb-4">Branże</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                "Elektryk",
                "Hydraulik",
                "Dekarz",
                "Brukarz",
                "Ogrodzenia",
                "Klimatyzacja",
                "Remonty",
                "Inne usługi lokalne",
              ].map((b) => (
                <li key={b}>
                  <span className="text-sm text-gray-500">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400 text-center sm:text-left">
            &copy; {new Date().getFullYear()} Strony www dla firm usługowych. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/polityka-prywatnosci" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors whitespace-nowrap">Polityka prywatności</Link>
            <Link to="/rodo" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors whitespace-nowrap">RODO</Link>
            <Link to="/regulamin" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors whitespace-nowrap">Regulamin</Link>
            <Link to="/polityka-cookies" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors whitespace-nowrap">Cookies</Link>
          </div>
        </div>
        <p className="text-center text-xs text-gray-300 mt-4">
          Realizuję <strong className="font-normal text-gray-400">strony internetowe dla firm usługowych</strong> na terenie całej Polski — 
          Warszawa, Kraków, Wrocław, Poznań, Gdańsk, Łódź, Katowice, Szczecin, Lublin, Białystok i innych miast.
        </p>
      </div>
    </footer>
  );
};

export default FooterSection;
